function DropIcon({ size = '27', style = {}, color = '#FFFEFE' }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 20 27"
      fill="none"
    >
      <path
        d="M9.99997 27C4.48567 27 0 22.4583 0 16.875C0 9.85642 9.0267 0.636114 9.41081 0.247202C9.73635 -0.0824006 10.2637 -0.0824006 10.5892 0.247202C10.9733 0.636114 20 9.85642 20 16.875C20 22.4582 15.5143 27 9.99997 27ZM9.99997 2.06397C8.01025 4.22111 1.66664 11.5182 1.66664 16.8749C1.66664 21.5271 5.40522 25.3124 9.99997 25.3124C14.5947 25.3124 18.3333 21.5271 18.3333 16.8749C18.3334 11.5133 11.9906 4.22029 9.99997 2.06397Z"
        fill={color}
      />
    </svg>
  );
}

export default DropIcon;
